import { useTranslation } from 'react-i18next';
import InputField from '../../../../../components/fields/InputField';
import SelectField from '../../../../../components/fields/SelectField';
import TranslatedInputField from '../../../../../components/fields/TranslatedInputField';
import useSystemOptions from '../../../../../utilities/useSystemOptions';

type RouterMenuItemCustomProps = {
    name: string;
};

const RouterMenuItemCustom = ({ name }: RouterMenuItemCustomProps) => {
    const { t } = useTranslation('routerDetails');
    const { antdIconOptions } = useSystemOptions();

    return (
        <>
            <TranslatedInputField
                {...t('routerDetails:menuItems.fields.label', { returnObjects: true })}
                name={`${name}.label`}
                required
            />

            <SelectField
                {...t('routerDetails:menuItems.fields.icon', { returnObjects: true })}
                name={`${name}.icon`}
                options={antdIconOptions}
                showSearch
            />

            <InputField
                {...t('routerDetails:menuItems.fields.pathname', { returnObjects: true })}
                name={`${name}.pathname`}
                required
            />
        </>
    );
};

export default RouterMenuItemCustom;
